import { useEffect, useState } from 'react';
import { NAZIVI_ULOGA } from '../lib/konstante';

export default function PravaPristupa({ korisnikId, naDohvat, naSpremi }) {
  const [profili, postaviProfile] = useState([]);
  const [izbori, postaviIzbore] = useState({});
  const [ucitava, postaviUcitava] = useState(true);
  const [radi, postaviRadi] = useState(null);
  const [greska, postaviGresku] = useState(null);
  const [poruka, postaviPoruku] = useState(null);
  const [pokusaj, postaviPokusaj] = useState(0);
  useEffect(() => {
    let aktivno = true;
    postaviUcitava(true);
    naDohvat()
      .then((podaci) => {
        if (aktivno) {
          postaviProfile(podaci);
          postaviIzbore(Object.fromEntries(podaci.map((p) => [p.id, p.uloga])));
          postaviGresku(null);
        }
      })
      .catch((e) => {
        if (aktivno) postaviGresku(e.message);
      })
      .finally(() => {
        if (aktivno) postaviUcitava(false);
      });
    return () => {
      aktivno = false;
    };
  }, [naDohvat, pokusaj]);
  if (ucitava)
    return (
      <div className="cekanje">
        <span className="ucitavanje" />
        <p>Učitavam račune…</p>
      </div>
    );
  return (
    <section className="ploca prava-pristupa">
      <div className="zaglavlje-uvoza">
        <div>
          <h2>Uloge postojećih računa</h2>
          <p>
            Dodijeli ulogu popisivača računu koji će unositi kućanstva. Samo
            super admin mijenja uloge.
          </p>
        </div>
      </div>
      {greska && (
        <div className="obavijest greska" role="alert">
          {greska}
          <button
            className="tekst-gumb"
            onClick={() => postaviPokusaj(pokusaj + 1)}
          >
            Pokušaj ponovno
          </button>
        </div>
      )}
      {poruka && (
        <p className="poruka ok" role="status">
          {poruka}
        </p>
      )}
      {profili.map((p) => (
        <div className="redak-prava" key={p.id}>
          <div>
            <strong>{p.korisnicko_ime || p.ime || 'Račun'}</strong>
            <small>
              {p.id === korisnikId
                ? 'Tvoj račun'
                : p.uloga === 'popisivac'
                  ? 'Unos i uređivanje svih kućanstava'
                  : NAZIVI_ULOGA[p.uloga]}
            </small>
          </div>
          <label>
            <span className="samo-citac">Uloga računa {p.korisnicko_ime}</span>
            <select
              value={izbori[p.id]}
              disabled={radi != null || p.id === korisnikId}
              onChange={(e) =>
                postaviIzbore({ ...izbori, [p.id]: e.target.value })
              }
            >
              {Object.entries(NAZIVI_ULOGA).map(([v, n]) => (
                <option key={v} value={v}>
                  {n}
                </option>
              ))}
            </select>
          </label>
          <button
            className="gumb sek"
            disabled={
              radi != null || p.id === korisnikId || izbori[p.id] === p.uloga
            }
            onClick={async () => {
              postaviRadi(p.id);
              postaviGresku(null);
              postaviPoruku(null);
              try {
                await naSpremi(p.id, izbori[p.id]);
                postaviProfile(
                  profili.map((z) =>
                    z.id === p.id ? { ...z, uloga: izbori[p.id] } : z,
                  ),
                );
                postaviPoruku(
                  `Uloga za račun ${p.korisnicko_ime || p.ime} je spremljena. Primjenjuje se pri sljedećem učitavanju profila.`,
                );
              } catch (e) {
                postaviGresku(e.message);
              } finally {
                postaviRadi(null);
              }
            }}
          >
            {radi === p.id ? 'Spremam…' : 'Spremi ulogu'}
          </button>
        </div>
      ))}
      <p className="napomena-ploce">
        Popisivači zajednički uređuju sva kućanstva i kontakte. Uvoz iz Excela i
        financije dostupni su adminu i super adminu.
      </p>
    </section>
  );
}
